import React from "react";
import { Container } from "react-bootstrap";
import { BASE_URL } from "../../constants";

const CoreComponents = () => {
  return (
    <Container>
      <div className="packages-container">
        <h1 className="corecomp-heading">Core Components</h1>

        {/* First Row */}
        <div className="row">
          <div className="package-item">
            <img
              src={`${BASE_URL}core_components/ai_image.png`}
              alt="Power"
              className="package-image"
            />
            <h2 className="package-heading">AI</h2>
            <p className="package-text">
              Harness the power of AI to automate analysis, identify
              optimization opportunities, and accelerate decision-making in the
              energy sector.
            </p>
          </div>

          <div className="package-item">
            <img
              src={`${BASE_URL}core_components/no_code.png`}
              alt="Hydrogen"
              className="package-image"
            />
            <h2 className="package-heading">No Code Analysis</h2>
            <p className="package-text">
              Enable users to create, test, and refine energy simulations
              effortlessly without any coding expertise, making advanced
              analytics accessible to all.
            </p>
          </div>

          <div className="package-item">
            <img
              src={`${BASE_URL}core_components/economics .png`}
              alt="Field Development Plan"
              className="package-image"
            />
            <h2 className="package-heading">Detailed Economics </h2>
            <p className="package-text">
              Conduct in-depth financial analysis with precise cost modeling,
              return on investment (ROI) calculations, and risk assessments for
              sustainable energy projects.
            </p>
          </div>
        </div>

        {/* Second Row */}
        <div className="row">
          <div className="package-item">
            <img
              src={`${BASE_URL}core_components/market_intelligence.png
`}
              alt="CCUS"
              className="package-image"
            />
            <h2 className="package-heading">Market Intelligence</h2>
            <p className="package-text">
              Access real-time industry data, trends, and forecasts to make
              informed strategic decisions based on the latest market
              intelligence.
            </p>
          </div>

          <div className="package-item">
            <img
              src={`${BASE_URL}core_components/dashboard.png`}
              alt="Ammonia"
              className="package-image"
            />

            <h2 className="package-heading">Flexible Reports and Dashboard</h2>
            <p className="package-text">
              Instantly generate detailed, data-driven reports that provide
              clear insights into operational, financial, and sustainability
              metrics. Customize dashboards to visualize key performance
              indicators{" "}
            </p>
          </div>

          <div className="package-item">
            <img
              src={`${BASE_URL}core_components/collaboration .png`}
              alt="Biofuel"
              className="package-image"
            />
            <h2 className="package-heading">Collaboration</h2>
            <p className="package-text">
              Enable seamless teamwork with shared project spaces, real-time
              data updates, and integrated communication tools to enhance
              cross-functional decision-making.
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CoreComponents;
